var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.531799,
    width: 32.375,
    height: 32.6257,
    rx: 16.1875,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3746 16.3129C23.375 16.5038 23.3261 16.6917 23.2324 16.8582C23.1388 17.0246 23.0037 17.164 22.8402 17.2628L12.7096 23.4601C12.5388 23.5647 12.3432 23.6218 12.1429 23.6255C11.9427 23.6292 11.7451 23.5794 11.5705 23.4812C11.3976 23.3845 11.2536 23.2436 11.1533 23.0728C11.0529 22.902 10.9999 22.7076 10.9996 22.5095V10.1162C10.9999 9.91813 11.0529 9.7237 11.1533 9.55292C11.2536 9.38213 11.3976 9.24116 11.5705 9.14449C11.7451 9.0463 11.9427 8.99648 12.1429 9.00019C12.3432 9.0039 12.5388 9.061 12.7096 9.16559L22.8402 15.3629C23.0037 15.4617 23.1388 15.6011 23.2324 15.7675C23.3261 15.934 23.375 16.1219 23.3746 16.3129Z",
    fill: "url(#paint0_linear_172_858)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_172_858",
    x1: 17.1575,
    y1: 26.9749,
    x2: 17.1575,
    y2: 11.5196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B0000",
    stopOpacity: 0.376471
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B22222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D4D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/PlayBtn.1bdff6417671d904c4074673ac3e96d7.svg";
export { ForwardRef as ReactComponent };